import { useContext } from 'react';
import { ratingContext } from '../contexts/RatingContext';

export function useRating() {
  const value = useContext(ratingContext);
  return value;
}
